var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132.14,
    height: 103.09,
    viewBox: "0 0 132.14 103.09",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#2a3561",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M1348.668 1049.76h-127.122a2.259 2.259 0 0 0-2.259 2.259v77.912a2.258 2.258 0 0 0 2.259 2.259h33.893V1152l19.807-19.806h73.423a2.259 2.259 0 0 0 2.259-2.259v-77.912a2.259 2.259 0 0 0-2.259-2.259z",
    transform: "translate(-1219.037 -1049.51)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34f5cf",
    stroke: "#2a3561",
    strokeMiterlimit: 10,
    strokeWidth: "0.5px",
    d: "M1416.412 1152.627a22.391 22.391 0 1 1 22.391 22.392 22.417 22.417 0 0 1-22.391-22.392z",
    transform: "translate(-1219.037 -1049.51) translate(-153.696 -62.746)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1468.5 1210.608a1.587 1.587 0 0 1-1.125-.466l-5.469-5.469a1.592 1.592 0 0 1 2.251-2.25l4.344 4.344 8.651-8.651a1.592 1.592 0 0 1 2.251 2.251l-9.776 9.776a1.587 1.587 0 0 1-1.125.466z",
    transform: "translate(-1219.037 -1049.51) translate(-185.551 -113.017)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.a46c18a4abc4b0bbf390c515c9949845.svg";
export { ForwardRef as ReactComponent };